"use client";

import { FolderIcon } from "@/components/icons";

/** The inline name field a new or renamed department is typed into. */
export function FolderEditInput({
  depth,
  value,
  onChange,
  onCommit,
  onCancel,
}: {
  depth: number;
  value: string;
  onChange: (value: string) => void;
  onCommit: () => Promise<void>;
  onCancel: () => void;
}) {
  return (
    <div
      className="flex h-9 items-center gap-1.5 pr-2"
      style={{ paddingLeft: `${28 + depth * 14}px` }}
    >
      <FolderIcon className="size-3.5 shrink-0 text-zinc-500" />
      <input
        autoFocus
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === "Enter") void onCommit();
          if (e.key === "Escape") onCancel();
        }}
        onBlur={() => onCancel()}
        placeholder="Department name"
        className="w-full min-w-0 rounded border border-violet-500/60 bg-zinc-950 px-1.5 py-0.5 text-sm text-zinc-100 outline-none placeholder:text-zinc-600"
      />
    </div>
  );
}
